<div class="flex flex-col space-y-[1.4rem]">
  <div class="flex !w-full flex-col space-y-[0.4rem]">
    <div class="flex items-center space-x-[0.6rem]">
      <i class="icon_new icon_warn text-[2.2rem] !text-[#FF7C7C]"></i>
      <span i18n="@@payment.cardsError.title" class="text-[1.5rem] font-450 leading-[2.2rem] text-[#FF7C7C]"
        >Ошибка!</span
      >
    </div>
    <span class="text-[1.2rem] font-350 leading-[1.6rem] text-[#FFD8D8] opacity-90">{{ message }}</span>
  </div>
  <div class="h-[0.6rem] w-full overflow-hidden rounded-[0.5rem] bg-[rgba(105,30,30,0.80)]">
    <div class="animate-fill h-full w-full rounded-[0.5rem] bg-[#EA6060]"></div>
  </div>
</div>
<button
  class="hover:bg-[rgba(244,132,132,0.43] absolute right-[1.6rem] top-[1.6rem] flex h-[1.8rem] w-[1.8rem] items-center justify-center rounded-[0.6rem] bg-[rgba(244,132,132,0.23)] !text-[#EDAAAA] custom-transition-all hover:!text-[#FFD8D8]"
  (click)="close()"
>
  <i class="icon icon_cross text-[0.8rem]"></i>
</button>
